/**************************************************************************************************/
/*   File: /src/app/shared/components/homepage/homepage.ts                                        */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Thu May 30 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { timer, Subscription, Observable,of } from 'rxjs';
import { take } from 'rxjs/operators';

import { Component, OnInit, OnDestroy } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { NGXLogger } from 'ngx-logger';

import * as fromShared from '../../../shared';
import * as fromStore from '../../../stores';
import * as fromActions from '../../../stores/actions';

import { Store } from '@ngrx/store';
/**
 * The homepage component
 */
@Component({
  selector: 'nwpl-frnt-homepage',
  templateUrl: './homepage.html',
  styleUrls: ['./homepage.scss'],
  animations: [
    trigger('card', [
      transition(':enter', [
        style({ transform: 'scale(0.5)', opacity: 0 }),  // initial
        animate('{{time}}s cubic-bezier(.8, -0.6, 0.2, 1.5)',
          style({ transform: 'scale(1)', opacity: 1 }))  // final
      ])
    ])
  ]
})
export class HomepageComponent implements OnInit, OnDestroy {

  /**
   * Delayed show
   */
  /* istanbul ignore next */
  delayedShow = false;
  /**
   * Time interval
   */
  /* istanbul ignore next */
  time = 200;
    /**
   * The current language async
   * @type {Observable<fromShared.models.Language>}
   */
    currentLanguage$: Observable<fromShared.models.Language>;

    private subscriptions: Subscription[] = [];

    egovLogged$: Observable<boolean>;

    /**
     * The contructor
     * @param {fromStore.states.fromRoot.RootState} store The store
     * @param {NGXLogger} logger The logger
     */
  /**
   * The constructor
   */
  constructor(private logger: NGXLogger, private store: Store<fromStore.states.fromRoot.RootState>) {
  }

  /**
   * The ng on init hook
   */
  /* istanbul ignore next */
  ngOnInit() {

    // tslint:disable-next-line
    this.currentLanguage$ = this.store.select(fromStore.selectors.fromUi.getCurrentLanguage);

    /* istanbul ignore next */
    const subscriptionTimer = timer(0, this.time).pipe(
      take(5)
    ).subscribe(() => {
      this.delayedShow = true;
    });
    this.subscriptions.push(subscriptionTimer);
  }
  /**
   * The ng on destroy hook
   */
  /* istanbul ignore next */
  ngOnDestroy(): void {
    /* this.logger.trace('Remove subscriptions HomepageComponent'); */
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

    /**
   * Handler for navigation
   * Dispatched when user authorized wants to go to sub section
   * @param {string} path the path to navigate to
   */
      goTo(path: string) {
        //this.egovLogged$ = of(true);

        const subscription = this.currentLanguage$.subscribe(currentLanguage => {
          const pathArray = ['', path];
          
          this.store.dispatch(
            new fromActions.fromRouter.Go({
              path: pathArray,
              query: {
                isoCode: currentLanguage.isoCode
              }
            })
          );
        });

        this.subscriptions.push(subscription);
    }


}
